import React from "react";
import { FaTimes, FaFacebookF, FaWhatsapp, FaFacebookMessenger, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, FaPinterestP } from "react-icons/fa";

const ContactsDrawer = ({ isOpen, onClose }) => {
  return (
    <div className={`contacts-drawer ${isOpen ? "open" : ""}`}>
      <div className="drawer-header">
        <h2>Contact Us</h2>
        <button className="drawer-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
      </div>
      <hr className="drawer-divider" />
      <div className="drawer-content">
        <p>Get in touch with us for your transportation needs.</p>
        <div className="contact-buttons">
          <a className="contact-icon" href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a className="contact-icon" href="https://wa.me/9142762961" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
          <a className="contact-icon" href="https://m.me/" target="_blank" rel="noopener noreferrer">
            <FaFacebookMessenger />
          </a>
          <a className="contact-icon" href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <FaTwitter />
          </a>
          <a className="contact-icon" href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a className="contact-icon" href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn />
          </a>
          <a className="contact-icon" href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
          </a>
          <a className="contact-icon" href="https://pinterest.com" target="_blank" rel="noopener noreferrer">
            <FaPinterestP />
          </a>
        </div>
        <div className="branding">FIBARN</div>
      </div>
      <style>{`
        .contacts-drawer {
          position: fixed;
          top: 0;
          right: 0;
          width: 180px;
          height: 100%;
          background: rgba(255, 255, 255, 0.95);
          border-left: 1px solid #2B3F50;
          box-shadow: -2px 0 8px rgba(0,0,0,0.3);
          transform: translateX(100%);
          transition: transform 0.3s ease;
          z-index: 101;
          display: flex;
          flex-direction: column;
          backdrop-filter: brightness(1.05);
        }
        .contacts-drawer.open {
          transform: translateX(0);
        }
        .drawer-header {
          background: rgba(248,248,248,0.95);
          border-bottom: 1px solid #ddd;
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .drawer-divider {
          border: 0;
          height: 1px;
          background: #2B3F50;
          margin: 0;
        }
        .drawer-content {
          padding: 16px;
          overflow-y: auto;
          flex: 1;
          text-align: center;
        }
        .contact-buttons {
          display: flex;
          flex-direction: column;
          gap: 15px;
          align-items: center;
          margin-top: 10px;
        }
        .contact-icon {
          font-size: 36px;
          color: #0d2b3e;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .contact-icon:hover {
          transform: scale(1.2);
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
        }
        .branding {
          margin-top: 20px;
          font-size: 20px;
          font-weight: bold;
          color: #0d2b3e;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }
      `}</style>
    </div>
  );
};

export default ContactsDrawer;
